import React, { useContext } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { VehicleContext } from '../Context/VehicleContext';
import {useNavigate} from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';

const ContactForm = () => {

    const {submitContactForm} = useContext(VehicleContext);
    const recaptchaRef = React.useRef();

    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        fullName: Yup.string()
            .required('Full Name is required'),
        email: Yup.string()
            .email('Invalid email address')
            .required('Email is required'),
        phone: Yup.string()
            .required('Phone number is required'),
        comments: Yup.string()
            .max(500, 'Comments cannot exceed 500 characters')
    });

    const handleSubmit = (values) => {
        console.log(values);
        // Handle form submission (e.g., send data to an API)
    };

    return (
        <Formik
            initialValues={{ fullName: '', email: '', phone: '', comments: '' }}
            validationSchema={validationSchema}
            onSubmit={async (values, { resetForm }) => {
                const token = await recaptchaRef.current.executeAsync();
                recaptchaRef.current.reset(); // Reset after use

                values.token = token;

                console.log(values);
                const data = await submitContactForm(values);

                if (data.success) {
                    resetForm();
                    navigate("/thank-you");
                } else
                    alert("There was a problem with your submission");
            }}
        >
            {({ handleSubmit }) => (
                <Form className='custom-form contact-form' onSubmit={handleSubmit}>
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey="6LfuE4MrAAAAAJdFHXLQK_ktBMzfl8C9I5fpmiJU" // Replace with your actual site key
                        size="invisible"
                    />
                    <div className='form-group'>
                        <label className='cs-label' htmlFor='fullName'>Full Name</label>
                        <Field type='text' name='fullName' className='form-control' />
                        <ErrorMessage name='fullName' component='div' className='text-danger' />
                    </div>
                    <div className='form-group'>
                        <label className='cs-label' htmlFor='email'>Email</label>
                        <Field type='text' name='email' className='form-control' />
                        <ErrorMessage name='email' component='div' className='text-danger' />
                    </div>
                    <div className='form-group'>
                        <label className='cs-label' htmlFor='phone'>Phone</label>
                        <Field type='text' name='phone' className='form-control' />
                        <ErrorMessage name='phone' component='div' className='text-danger' />
                    </div>
                    <div className='form-group'>
                        <label className='cs-label' htmlFor='comments'>Comments</label>
                        <Field as='textarea' name='comments' className='form-control h-150' />
                        <ErrorMessage name='comments' component='div' className='text-danger' />
                    </div>
                    <div className='mt-5 pt-2'>
                        <button type='submit' className='transparent-btn w-100 text-uppercase'>Send</button>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default ContactForm;
